import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { styled, useTheme } from 'styled-components';
import { Loader } from '../../V2/Elements/Loader';
const StyledInput = styled.input `
  border-radius: 4px;
  width: 100%;
  border: solid 1px ${({ theme }) => theme.colors.grey30_1};
  height: ${({ rows }) => (rows && rows > 1 ? `${rows * 25}px` : '38px')};
  padding: ${({ clearButton }) => (clearButton ? '8px 38px 8px 12px' : '8px 12px')};
  font-size: 14px;
  font-family: CircularXXWeb, Roboto, sans-serif;
  color: ${({ theme }) => theme.colors.black_1};
  resize: none;
  transition: all 100ms;
  appearance: none;
  background-color: ${({ theme }) => theme.colors.grey00_7};

  &::placeholder {
    color: ${({ theme }) => theme.colors.grey70_1};
  }

  &[disabled],
  &[readonly] {
    background-color: ${({ theme }) => theme.colors.grey05_3};
    border-color: ${({ theme }) => theme.colors.grey30_2};
  }

  &[disabled] {
    color: ${({ theme }) => theme.colors.grey100_2};
    &::placeholder {
      color: ${({ theme }) => theme.colors.grey100_2};
    }
  }

  &:focus {
    border-color: ${({ theme }) => theme.colors.main};
    outline: none;
    box-shadow: 0 0 0 1px ${({ theme }) => theme.colors.main};
  }

  &:not([disabled], [readonly], :focus):hover {
    border-color: ${({ theme }) => theme.colors.grey70_1};
  }
`;
const InputContainer = styled.div `
  position: relative;
  width: 100%;
`;
const IconContainer = styled.div `
  position: absolute;
  right: 12px;
  top: calc(50% - 7px);
`;
const Input = React.forwardRef(function Input({ loading, dataTestId, ...props }, ref) {
    const { colors } = useTheme();
    return (_jsxs(InputContainer, { "data-testid": dataTestId, children: [_jsx(StyledInput, { ...props, ref: ref }), loading ? (_jsx(IconContainer, { children: _jsx(Loader, { fill: colors.grey100_1, background: 'transparent' }) })) : null] }));
});
export { Input };
